import type { ReactNode } from 'react';

/**
 * Shared full-bleed background for Home and survey flow pages (`/images/bg_image.png` + vignette).
 * Keep background utility classes inline so Tailwind JIT picks them up.
 */
export default function SurveyBackgroundLayout({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex h-full min-h-0 flex-1 flex-col px-6 pb-12 bg-top bg-no-repeat bg-[length:100%_auto] bg-[url('/images/bg_image.png')]">
      <div
        className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/25 via-transparent to-black/45"
        aria-hidden
      />
      {children}
    </div>
  );
}
